<template>
    <div>
        <div class="my-3">
            <div class="flex flex-wrap mt-2 mb-2">
                <ColorPreset v-for="(preset, idx) in presets" :key="idx"
                    :color="preset.color"
                    :background="preset.background"
                    @click="applyColorPreset(preset)"
                ></ColorPreset>
            </div>

            <!-- Select amplitude -->
            <div v-if="waveConfigurations.length > 1" class="tabs flex text-green">
                <span class="tab flex py-2 px-3" v-for="(wave, idx) in waveConfigurations"
                    :class="{'active': activeAmplitudeColors==idx}">
                    <a href="#"
                        class="text-green uppercase"
                        :class="{'font-semibold': activeAmplitudeColors==idx}"
                        @click="activeAmplitudeColors=idx"
                    ><span class="tab-icon"></span>{{ idx+1 }}</a>
                </span>
            </div>

            <!-- Configure amplitude -->
            <div v-for="(wave,idx) in waveConfigurations">
                <div v-show="activeAmplitudeColors==idx">
                    <WaveColors
                        ref="pickers"
                        :idx="idx"
                        :colorPreset="wave.color"
                        :backgroundColorPreset="wave.backgroundColor">
                    </WaveColors>
                </div>
            </div>
        </div>

        <!-- <div class="grid grid-cols-2 form-element-wrapper">
            <div v-show="border == 'border'" class="form-element">
                <div class="label">Rahmenfarbe</div>
                <ColorPicker name="borderColor"
                    :value="borderColor"
                    @change="setBorderColor($event)"
                ></ColorPicker>
            </div>
        </div> -->
    </div>
</template>

<script>
import WaveColors from "./WaveColors.vue";
import { mapFields } from 'vuex-map-fields';
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import ColorPicker from "../../../Components/ColorPicker.vue";
import ColorPreset from "../../../Components/ColorPreset.vue";

export default {
    components: {
        WaveColors,
        ColorPicker,
        ColorPreset
    },

    data() {
        return {
            activeAmplitudeColors: 0
        };
    },

    computed: {
        ...mapFields({
            presets: 'presets',
            border: 'stageConfiguration.border',
            waveConfigurations: 'waveConfigurations',
            borderColor: 'stageConfiguration.borderColor'
        })
    },

    methods: {
        applyColorPreset(preset, idx = null) {

            if (idx === null) {
                for (let i = 0; i < this.waveConfigurations.length; i++) {
                    const picker = this.$refs.pickers[i];
                    if (picker) {
                        picker.setColor(preset.color);
                        picker.setBackgroundColor(preset.background);
                    }
                }

                Pipeline.applyColorPreset(preset);
            } else {
                const picker = this.$refs.pickers[idx];
                if (picker) {
                    picker.setColor(preset.color);
                    picker.setBackgroundColor(preset.background);
                }

                Pipeline.applySingleColorPreset(preset, idx);
            }
        },

        /**
         * Change border color
         */
        setBorderColor(borderColor) {
            this.$store.commit('updateField', {
                path: `stageConfiguration.borderColor`,
                value: borderColor
            });

            this.$store.commit('updateField', {
                path: `stageConfiguration.borderColor2`,
                value: null
            });

            Pipeline.updateStageBorder();
        }
    }
}
</script>
